import logo from './../assets/images/lcmslogo.svg';

export default function LCMSLogo() {
    return (
        <img src={logo} className="img-center img-fluid img-footer-logo" height="35" width="237" alt="The Lutheran—Missouri Synod" />
    );
}
